import { Button, HStack } from '@chakra-ui/react';
import React from 'react';

import { CODE_TYPES, CODE_TYPE_LABEL, type CodeType } from '../../interface/codes';
import { ADD_CODE_DIALOG as D, INK, INK_SOFT } from '../../styles/tokens';

export type CodeTypeChipsProps = {
  readonly value: CodeType;
  readonly onChange: (next: CodeType) => void;
};

export const CodeTypeChips: React.FC<CodeTypeChipsProps> = ({ value, onChange }) => {
  const buttons = React.useRef<Partial<Record<CodeType, HTMLButtonElement | null>>>({});
  const step = (delta: number): void => {
    const index = CODE_TYPES.indexOf(value);
    const next = CODE_TYPES[(index + delta + CODE_TYPES.length) % CODE_TYPES.length];
    onChange(next);
    buttons.current[next]?.focus();
  };
  const onKeyDown = (event: React.KeyboardEvent): void => {
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
      event.preventDefault();
      step(1);
    } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
      event.preventDefault();
      step(-1);
    }
  };
  return (
    <HStack role="radiogroup" aria-label="Code type" spacing="4px">
      {CODE_TYPES.map((codeType) => {
        const checked = codeType === value;
        return (
          <Button
            key={codeType}
            ref={(el: HTMLButtonElement | null) => {
              buttons.current[codeType] = el;
            }}
            role="radio"
            aria-checked={checked}
            tabIndex={checked ? 0 : -1}
            h="25px" minW="0" px="12px" py="4px" fontSize="12px" fontWeight={600}
            borderRadius="14px" borderWidth="1px" borderStyle="solid"
            borderColor={checked ? INK : D.rule}
            variant={checked ? 'solid' : 'outline'}
            bg={checked ? INK : 'transparent'}
            color={checked ? 'white' : INK_SOFT}
            _hover={{ bg: checked ? INK : 'gray.100' }}
            onClick={() => onChange(codeType)}
            onKeyDown={onKeyDown}
          >
            {CODE_TYPE_LABEL[codeType]}
          </Button>
        );
      })}
    </HStack>
  );
};
